import { schema } from 'normalizr';

export const user = new schema.Entity('users');
export const item = new schema.Entity('items');
export const claim_question = new schema.Entity('claim_questions');
export const category = new schema.Entity('categories');




// WEBPACK FOOTER //
// ./src/snapit_app/schema.js